import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'
import lookups from '@/assets/json/clientLookups.json'
import apiHelperService from '@/services'
import useCommonFun from '@/composables/useCommonFun'

const relationshipWatch = () => {
  const relationshipIdWatch = ref()
  const formStore = useFormStore()
  relationshipIdWatch.value = watch(
    () => formStore.form.values.familyRelationshipId,
    async (newVal) => {
      formStore.extraMap.isDisableGender = false;
      if (newVal) {
        const cachedData = await apiHelperService.get('/api/lookup/GetFamilyRelations')
        if (cachedData) {
          let curObj = cachedData.find((item) => item.id == newVal)
          const { genderId } = curObj
          formStore.form.setFieldValue('genderId', genderId)
          if(genderId) {
            formStore.extraMap.isDisableGender = true;
          }
        }
      }
    }
  )
  onUnmounted(() => {
    relationshipIdWatch.value && relationshipIdWatch.value()
  })
}

const dateOfBirthWatch = () => {
  const birthDateWatch = ref()
  const formStore = useFormStore()

  const {
    maritalStatuses: { Single },
    educationLevels: { none },
    professions: { notEmployed }
  } = lookups
  birthDateWatch.value = watch(
    () => formStore.form.values.dateOfBirth,
    (newVal) => {
      if (newVal && useCommonFun().ageComparison(newVal, 15, '<=')) {
        formStore.form.setValues({
          maritalStatusId: Single,
          educationLevelId: none,
          professionId: notEmployed
        })
      }
    }
  )
  onUnmounted(() => {
    birthDateWatch.value && birthDateWatch.value()
  })
}

const currentNationalityWatch = () => {
  const currentNationalityIdWatch = ref()
  const formStore = useFormStore()
  currentNationalityIdWatch.value = watch(
    () => formStore.form.values.currentNationalityId,
    (newVal) => {
      if (newVal) {
        formStore.form.setFieldValue('passportCountryId', newVal)
      }
    }
  )
  onUnmounted(() => {
    currentNationalityIdWatch.value && currentNationalityIdWatch.value()
  })
}

const loadImmigrationFile = async (fileNubmer = '', moduleId = '') => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  let data = {
    fileModuleId: moduleId,
    sponsoredFileNumber: fileNubmer,
    serviceTransactionId,
    sponsoredType: 1
  }
  let res = await axios.request({
    url: '/api/udb/personImmigrationFile/prepare',
    method: 'POST',
    data
  })
  if (res) {
    const visaRequestDetails = res.data.visaRequest
    mapFileWithVisaRequest(visaRequestDetails)
  }
}

const mapFileWithVisaRequest = (visaRequestDetails = {}) => {
  const formStore = useFormStore()
  const {
    familyRelationshipId,
    englishName,
    arabicName,
    currentNationalityId,
    genderId,
    dateOfBirth,
    countryOfBirthId,
    maritalStatusId,
    englishPlaceOfBirth,
    arabicPlaceOfBirth,
    motherEnglishName,
    motherArabicName,
    educationLevelId,
    professionId,
    religionId,
    faithId,
    passportTypeId,
    passportNumber,
    passportEnglishIssuePlace,
    passportArabicIssuePlace,
    passportExpiryDate,
    passportIssueDate,
    passportCountryId
  } = visaRequestDetails
  formStore.form.setValues({
    familyRelationshipId,
    englishName,
    arabicName,
    currentNationalityId,
    genderId,
    dateOfBirth,
    countryOfBirthId,
    maritalStatusId,
    englishPlaceOfBirth,
    arabicPlaceOfBirth,
    motherEnglishName,
    motherArabicName,
    educationLevelId,
    professionId,
    religionId,
    faithId,
    passportTypeId,
    passportNumber,
    passportEnglishIssuePlace,
    passportArabicIssuePlace,
    passportExpiryDate,
    passportIssueDate,
    passportCountryId
  })
}

const selectdCanceledFileWatch = () => {
  const currentNationalityNoWatch = ref()
  const formStore = useFormStore()
  currentNationalityNoWatch.value = watch(
    () => formStore.form.values.selectdCanceledFileNo,
    (newVal) => {
      if (newVal) {
        const cachedData = sessionStorage.getItem('/api/individual/sponsored')
        if (cachedData) {
          const parseData = JSON.parse(cachedData)
          const { fileNumber = '', module = {} } = parseData.find(
            (item) => item.unifiedNumber == newVal
          )
          loadImmigrationFile(fileNumber, module.id)
        }
      }
    }
  )
  onUnmounted(() => {
    currentNationalityNoWatch.value && currentNationalityNoWatch.value()
  })
}

export default function () {
  return {
    relationshipWatch,
    dateOfBirthWatch,
    currentNationalityWatch,
    selectdCanceledFileWatch
  }
}
